import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import icons from '../assets/icons'
import Ship from '../types/Ship'
import regions from '../utils/regions'
import { unCapitalize } from '../utils/string'
import SelectComponent from './SelectComponent'
import SearchBar from './SearchBar'
import Stopover from '../types/Stopover'

type Props = {
  visible: boolean

  ships: Array<Ship>

  map: google.maps.Map | undefined

  onPickShip: (ship: Ship) => void

  onPickStop: (stopover: Stopover) => void
}

const queryParams = new URLSearchParams(window.location.search)
const regionCode = queryParams.get('region')

const isMobile = window.innerWidth < 1023

const Pickers: React.FC<Props> = ({ visible, ships, map, onPickShip, onPickStop }: Props) => {
  const [showShipPicker, setShowShipPicker] = useState(false)
  const [showRegionPicker, setShowRegionPicker] = useState(false)
  const [visibleInput, setVisibleInput] = useState(!isMobile)
  const { t } = useTranslation()

  const _onPickShip = useCallback(
    (ship: Ship) => {
      setShowShipPicker(false)
      onPickShip(ship)
    },
    [onPickShip],
  )

  const onPickRegion = useCallback(
    (region: any) => {
      setShowRegionPicker(false)
      if (map && region.points.length > 0) {
        const bounds = new google.maps.LatLngBounds()
        region.points.forEach((element: any) => {
          bounds.extend(element)
        })
        map.fitBounds(bounds)
      }
    },
    [map],
  )

  useEffect(() => {
    if (regionCode !== null) {
      const region = regions.find((item) => item.code === regionCode)
      if (region) {
        onPickRegion(region)
      }
    }
  }, [onPickRegion])

  const onPressShips = useCallback(() => {
    setShowRegionPicker(false)
    setShowShipPicker(!showShipPicker)
  }, [showShipPicker])

  const onPressRegions = useCallback(() => {
    setShowShipPicker(false)
    setShowRegionPicker(!showRegionPicker)
  }, [showRegionPicker])

  const toggleInput = () => {
    if (isMobile) {
      console.log('click')
      setVisibleInput((previousState) => !previousState)
    }
  }

  if (visible) {
    return (
      <div className='select--container'>
        <SearchBar onPickStop={onPickStop} visibleInput={visibleInput} toggleInput={toggleInput} />
        {(!isMobile || !visibleInput) && (
          <div className='select--rowItem'>
            <div className='select--div select--ship'>
              <SelectComponent
                visible={showShipPicker}
                srcImage={icons['ship']}
                onPressRow={onPressShips}
                title={t('pickers.ships')}
                data={ships.map((item) => ({
                  ...item,
                  // eslint-disable-next-line quotes
                  name: unCapitalize(item.name),
                }))}
                onPickItem={_onPickShip}
              />
            </div>
            <div className='select--div select--region'>
              <SelectComponent
                visible={showRegionPicker}
                srcImage={icons['region-picker']}
                onPressRow={onPressRegions}
                title={t('pickers.regions')}
                data={regions}
                onPickItem={onPickRegion}
              />
            </div>
          </div>
        )}
      </div>
    )
  }
  return null
}

export default Pickers
